export default __webpack_public_path__ + "static/MartySattison-1a4bd993ee6fde04650fd67e7584fc2d.jpg";